// extracted by mini-css-extract-plugin
export var indeterminate = "_1h-6";
export var md = "_1h-5";
export var semantic = "_1h-7";
export var sm = "_1h-4";
export var text = "_1h-8";
export var toggleControl = "_1h-0";
export var toggleInput = "_1h-1";
export var toggleSwitch = "_1h-2";
export var xs = "_1h-3";